// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3o2-2","col":"styles_col__VevS9"};